import { RecurrenceSettingsLayout } from './components/RecurrenceSettingsLayout'
import { CalendarConfigProvider } from './providers/CalendarConfigProvider'
import { StateProvider } from './providers/StateProvider'
import { UiFrameworkProvider } from './providers/UiFrameworkProvider'
import { RecurrenceSettingsProps } from './types'

export function RecurrenceSettings(props: RecurrenceSettingsProps) {
  const { onChange, value, uiFramework = 'legacy', inEditMode } = props

  return (
    <StateProvider fieldValue={value} onChange={onChange}>
      <CalendarConfigProvider>
        <UiFrameworkProvider uiFramework={uiFramework}>
          <RecurrenceSettingsLayout inEditMode={inEditMode} />
        </UiFrameworkProvider>
      </CalendarConfigProvider>
    </StateProvider>
  )
}
